const globals = {
    apiUrl: 'https://w.thorbroadcast.com/api'
}
export default globals
